// Unpublished Work © 2020-2022 Deere & Company

import {CustomerSearch} from '../../state/struct/customer-search/customer-search';
import * as actions from '../../action-list';
import {MergeCustomer} from '../../state/struct/customer-search/merge-customer';

const isTheSameCustomer = (customer, action) => customer.entityId === action.entityId && customer.contactId === action.contactId;

const setDuplicateMergeCustomer = (state, action) => MergeCustomer.update(state, {
    list: {
        $apply: () => state.list.map((customerItem) => ({
            ...customerItem,
            isPrimaryCustomer: isTheSameCustomer(customerItem, action) ? false : customerItem.isPrimaryCustomer
        }))
    }
});

const updatePrimaryMergeCustomer = (state, action) => MergeCustomer.update(state, {
    list: {
        $apply: () => state.list.map((customerItem) => ({
            ...customerItem,
            isPrimaryCustomer: isTheSameCustomer(customerItem, action)
        }))
    }
});

const addMergeCustomerItem = (state, action) => MergeCustomer.update(state, {
    list: {
        $push: [action.mergeCustomerItem]
    }
});

const removeMergeCustomerItem = (state, action) => {
    let update = {};
    const mergeCustomerIndex = state.list.findIndex((item) => isTheSameCustomer(item, action));

    if (mergeCustomerIndex > -1) {
        update = {
            list: {
                $splice: [[mergeCustomerIndex, 1]]
            }
        };
    }

    return MergeCustomer.update(state, update);
};

const removeAllMergeCustomerItems = (state) =>
    MergeCustomer.update(state, {
        $set: new MergeCustomer({})
    });

const updateComments = (state, action) => MergeCustomer.update(state, {
    comments: {
        $set: action.comments
    }
});

export const mergeCustomer = (state = new CustomerSearch({}).mergeCustomer, action = {}) => {
    const actionHandlers = {
        [actions.ADD_MERGE_CUSTOMER_ITEM]: addMergeCustomerItem,
        [actions.REMOVE_ALL_MERGE_CUSTOMER_ITEM]: removeAllMergeCustomerItems,
        [actions.REMOVE_MERGE_CUSTOMER_ITEM]: removeMergeCustomerItem,
        [actions.SET_DUPLICATE_MERGE_CUSTOMER]: setDuplicateMergeCustomer,
        [actions.UPDATE_MERGE_CUSTOMER_COMMENTS]: updateComments,
        [actions.UPDATE_PRIMARY_MERGE_CUSTOMER]: updatePrimaryMergeCustomer
    };
    const reducer = actionHandlers[action.type];

    return reducer ? reducer(state, action) : state;
};
